import { createClient } from '@supabase/supabase-js'

function getEnv(viteKey: string, nextKey: string): string {
  // Vite apps (studio, door)
  if (typeof import.meta !== 'undefined' && (import.meta as any).env?.[viteKey]) {
    return (import.meta as any).env[viteKey]
  }
  // Next.js apps (web, booking) + Node.js
  if (typeof process !== 'undefined' && process.env?.[nextKey]) {
    return process.env[nextKey]!
  }
  return ''
}

const supabaseUrl = getEnv('VITE_SUPABASE_URL', 'NEXT_PUBLIC_SUPABASE_URL')
const supabaseAnonKey = getEnv('VITE_SUPABASE_ANON_KEY', 'NEXT_PUBLIC_SUPABASE_ANON_KEY')

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Service role client (server-side only — Edge Functions)
export function createServiceClient() {
  const serviceKey = process.env.SUPABASE_SERVICE_ROLE_KEY
  if (!serviceKey) throw new Error('SUPABASE_SERVICE_ROLE_KEY not set')
  return createClient(supabaseUrl, serviceKey)
}

export { createClient }
